import React from 'react'

export default function PageNotFound() {
	return (
		<div>
			<h2 style={{ marginLeft: '50px' }}>404: Không tìm thấy trang</h2>
		</div>
	)
}
